import auth0js from 'auth0-js'

const auth0 = new auth0js.WebAuth({
    domain: `${process.env.VUE_APP_AUTH0_DOMAIN}`,
    clientID: `${process.env.VUE_APP_AUTH0_CLIENT_ID}`,
    redirectUri: `${process.env.VUE_APP_WEB_REDIRECT_URI}`,
    responseType: 'code',
    scope: 'openid profile email',
})

export function start(state) {
    auth0.authorize({ state })
}

export function signup(state) {
    auth0.authorize({'mode': 'signUp', state})
}

export function logout() {
  auth0.logout()
}
